<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">Login</div>
          <div class="card-body">
            <form @submit.prevent="login">
              <div class="mb-3">
                <label for="email" class="form-label">Email address</label>
                <input 
                  type="email" 
                  class="form-control" 
                  id="email" 
                  v-model="email" 
                  required
                >
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input 
                  type="password" 
                  class="form-control" 
                  id="password" 
                  v-model="password" 
                  required
                >
              </div>
              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-primary" :disabled="isLoading">
                  {{ isLoading ? 'Logging in...' : 'Login' }}
                </button>
                <button type="button" class="btn btn-secondary" @click="loginWithGoogle">
                  Login with Google
                </button>
              </div>
              <div v-if="error" class="alert alert-danger mt-3">
                {{ error }}
              </div>
            </form>
            <div class="text-center mt-3">
              <p>Don't have an account? <router-link to="/register">Register here</router-link></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { 
  signInWithEmailAndPassword, 
  signInWithPopup, 
  GoogleAuthProvider 
} from 'firebase/auth';
import { auth } from '@/firebase';

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const email = ref('');
    const password = ref('');
    const error = ref(null);
    const isLoading = ref(false);

    // Where to land after signing in: back where they were headed, or home.
    // Only same-site paths are accepted — an absolute URL in ?redirect= would
    // be an open redirect.
    const afterLogin = () => {
      const target = route.query.redirect;
      const safe = typeof target === 'string' && target.startsWith('/') && !target.startsWith('//');
      router.push(safe ? target : '/');
    };

    const login = async () => {
      error.value = null;
      isLoading.value = true;
      try {
        await signInWithEmailAndPassword(auth, email.value, password.value);
        afterLogin();
      } catch (err) {
        error.value = err.message;
      } finally {
        isLoading.value = false;
      }
    };

    const loginWithGoogle = async () => {
      error.value = null;
      isLoading.value = true;
      try {
        const provider = new GoogleAuthProvider();
        await signInWithPopup(auth, provider);
        afterLogin();
      } catch (err) {
        error.value = err.message;
      } finally {
        isLoading.value = false;
      }
    };

    return {
      email,
      password,
      error,
      isLoading,
      login,
      loginWithGoogle
    };
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>